var React = require('react');

function ArrowAltFromBottom (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M360 480H24a24 24 0 0 1-24-24v-16a24 24 0 0 1 24-24h336a24 24 0 0 1 24 24v16a24 24 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M232 384h-80a23.94 23.94 0 0 1-24-24V224H40.3c-17.8 0-26.8-21.51-14.2-34.11L178.4 37.63a19.36 19.36 0 0 1 27.3 0l152.1 152.23c12.6 12.6 3.7 34.11-14.1 34.11H256V360a23.94 23.94 0 0 1-24 24z","className":"fa-primary","key":2})]);
}

ArrowAltFromBottom.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowAltFromBottom;

ArrowAltFromBottom.default = ArrowAltFromBottom;
